import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import * as Yup from 'yup'
import { useMutation, useQuery } from '@apollo/client'
import { useLoading } from '../../../../../../LoadingOverlay/LoadingOverlayContext'
import Box from '../../../../../Global/Box'
import InputController from '../../../../../Global/InputController'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import { BoxItemData } from '../StatusDetails'
import {
  CREATE_STATUS_TRANSITION,
  GET_ALL_STATUS_AVAILABLE_TO_TRANSITIONS,
} from '../../../../../../graphql/Catalog/Status/StatusTransitions'

const validationSchema = Yup.object().shape({
  next_status_id: Yup.string().nullable().required('Campo requerido'),
})

const StatusTransitionsAdd = ({
  current_status_id,
  refetchMain,
  setCloseModal,
}) => {
  const { showLoading, hideLoading } = useLoading()
  const [optionsStatus, setOptionsStatus] = useState([])
  const [statusSelected, setStatusSelected] = useState(null)

  const {
    methods,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const {
    loading: loadingStatus,
    error: errorStatus,
    data: dataStatus,
    refetch: refetchStatus,
  } = useQuery(GET_ALL_STATUS_AVAILABLE_TO_TRANSITIONS, {
    variables: { current_status_id },
    fetchPolicy: 'network-only',
  })

  const [create] = useMutation(CREATE_STATUS_TRANSITION)

  useEffect(() => {
    try {
      if (loadingStatus) return
      if (errorStatus) throw errorStatus
      if (!dataStatus) throw new Error('No se encontraron datos de los estados')
      const list = dataStatus.getAllStatusAvailabesNotInTransitions.map(
        (item) => ({ value: item.id, label: item.name, item })
      )
      setOptionsStatus(list)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingStatus, errorStatus, dataStatus])

  const onSubmit = async (Data) => {
    showLoading()
    try {
      await create({
        variables: {
          current_status_id: current_status_id,
          next_status_id: parseInt(Data.next_status_id),
        },
      })

      toastSweetAlert({
        mode: 'ok',
        message: 'Transicion de estatus ha sido creada correctamente',
      })
      setStatusSelected(null)
      setValue('next_status_id', null)
      await refetchStatus()
      await refetchMain()
      return setCloseModal(true)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={'Agregar transicion de estatus'}
            btnSubmit
            btnSubmitText={'Agregar'}
            errors={errors}
            content={
              <>
                <div className="row">
                  <div className="col-lg-6">
                    <InputController
                      name="next_status_id"
                      label="Estatus siguiente"
                      control={control}
                      inputType="choosen"
                      options={optionsStatus}
                      menuPosition="fixed"
                      placeholderTxt="Selecciona un estatus"
                      changeAction={(e) => setStatusSelected(e)}
                      value={statusSelected?.id}
                      isClearable={true}
                    />
                  </div>
                </div>
                {statusSelected && (
                  <div className="row mt-3">
                    <div className="col-12">
                      <div>
                        <b>Informacion del rol seleccionado</b>
                      </div>
                      <div
                        className="d-flex flex-column flex-wrap"
                        style={{ gap: '5px' }}
                      >
                        <BoxItemData
                          title="TIPO"
                          value={statusSelected.item?.type}
                        />
                        <BoxItemData
                          title="NOMBRE"
                          value={statusSelected.item?.name}
                        />
                        <BoxItemData
                          title="PROGRESO"
                          value={
                            statusSelected.item?.progress
                              ? `${statusSelected.item.progress}%`
                              : 'N/A'
                          }
                        />
                        <BoxItemData
                          title="COLOR"
                          value={
                            statusSelected.item?.color ? (
                              <span
                                className="rounded px-1"
                                style={{
                                  backgroundColor: `${statusSelected.item.color}`,
                                }}
                              >
                                {statusSelected.item.color}
                              </span>
                            ) : (
                              'N/A'
                            )
                          }
                        />
                        <BoxItemData
                          title="ORDEN"
                          value={statusSelected.item?.order}
                        />
                        <BoxItemData
                          title="DESCRIPCION"
                          value={statusSelected.item?.description}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default StatusTransitionsAdd
